var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcoholAbstinenceInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    transform: "rotate(90 6 5)",
    stroke: "currentColor",
    strokeWidth: 2,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    transform: "rotate(90 18 19)",
    stroke: "currentColor",
    strokeWidth: 2,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1 4 23",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholAbstinenceInactive);
export default __webpack_public_path__ + "static/media/alcohol-abstinence-inactive.3c4f62aff6b151912cb25b2165865253.svg";
export { ForwardRef as ReactComponent };